import { useEffect } from 'react'
import { AuthProvider, useAuth } from './lib/auth.jsx'
import AuthGate from './components/AuthGate.jsx'
import Taskboard from './components/Taskboard.jsx'

function Gate() {
  const { user, loading } = useAuth()

  // Persisted theme (mockup behavior) — applied at the document level.
  useEffect(() => {
    try {
      const t = localStorage.getItem('tm-theme') || 'dark'
      document.documentElement.classList.toggle('light', t === 'light')
    } catch (e) {
      /* ignore */
    }
  }, [])

  if (loading) {
    return (
      <div
        style={{
          height: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: 'var(--color-bg-dark)',
          color: 'var(--color-muted)',
          fontFamily: 'var(--font-mono)',
          fontSize: 12,
          letterSpacing: '.08em',
          textTransform: 'uppercase',
        }}
      >
        Loading…
      </div>
    )
  }

  return user ? <Taskboard /> : <AuthGate />
}

export default function App() {
  return (
    <AuthProvider>
      <Gate />
    </AuthProvider>
  )
}
